import React from 'react';
import { motion } from 'framer-motion';
import { FiDownload, FiMail } from 'react-icons/fi';
//import profileImage from '../assets/images/profile.jpg';

const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  // Function to handle resume download
  const handleResumeDownload = () => {
    const link = document.createElement('a');
    link.href = '/resume/Atharv_Patil_Patki_ Resume_NEW.pdf';
    link.download = 'Atharv_Patil_Patki_ Resume_NEW.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Function to handle Let's Connect button - Scroll to Contact Section
  const handleLetConnect = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="flex flex-col lg:flex-row items-center justify-between"
        >
          {/* Left Content */}
          <div className="lg:w-1/2 text-center lg:text-left">
            <motion.div variants={itemVariants} className="mb-4">
              <span className="inline-block px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium">
                👋 Welcome to my portfolio
              </span>
            </motion.div>
            
            <motion.h1 
              variants={itemVariants}
              className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6"
            >
              Hi, I'm{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
                Atharv Patil Patki
              </span>
            </motion.h1>
            
            <motion.p 
              variants={itemVariants}
              className="text-xl lg:text-2xl text-gray-600 mb-6"
            >
              BTech CSE Student
            </motion.p>
            
            <motion.p 
              variants={itemVariants}
              className="text-lg text-gray-600 mb-8 max-w-2xl"
            >
              I am a passionate computer science student with hands-on experience in Python, web development, and database technologies. I have worked on academic and personal projects that strengthened my problem-solving skills and understanding of full-stack development. I am eager to apply my knowledge, learn from industry experts, and contribute to meaningful projects.


            </motion.p>
            
            <motion.div 
              variants={itemVariants}
              className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start"
            >
              <motion.button
                onClick={handleResumeDownload}
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
                className="inline-flex items-center px-6 py-3 bg-primary text-white rounded-lg font-medium hover:bg-secondary transition-colors duration-200"
              >
                <FiDownload className="mr-2" />
                Download Resume
              </motion.button>
              
              <motion.button
                onClick={handleLetConnect}
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
                className="inline-flex items-center px-6 py-3 border-2 border-primary text-primary rounded-lg font-medium hover:bg-primary hover:text-white transition-all duration-200"
              >
                <FiMail className="mr-2" />
                Let's Connect
              </motion.button>
            </motion.div>
          </div>
          
          {/* Right Content - Photo */}
          <motion.div 
            variants={itemVariants}
            className="lg:w-1/2 mt-12 lg:mt-0 flex justify-center"
          >
            <div className="relative">
              {/* Animated border */}
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                className="absolute -inset-4 bg-gradient-to-r from-primary to-secondary rounded-full opacity-20"
              />
              
              {/* Image container */}
              <motion.div 
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
                className="relative w-64 h-64 lg:w-80 lg:h-80 rounded-full overflow-hidden bg-gray-200 shadow-2xl border-4 border-white"
              >
                <img 
                  src="/images/profile.jpg"
                  alt="Atharv Patil Patki - Python Developer & Backend Enthusiast" 
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  loading="lazy"
                />
              </motion.div>
              
              {/* Optional: Status indicator (online/available) */}
              <div className="absolute bottom-6 right-6 w-6 h-6 bg-green-500 rounded-full border-4 border-white shadow-lg"></div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
